export * from './history';
export * from './claim';

import { createStore } from 'hox';
import { useProfile, useToken } from '../user';
import { adminTrpc, adminTrpcApi } from '@bitbot/api';
import Decimal from 'decimal.js';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useWallets } from '../wallet';
export const [useInvite, InviteProvider] = createStore(() => {
  const { hasLogin } = useToken();
  const { currentWallet } = useWallets();
  const { data: spinInfoRes, isLoading: isLoadingSpinInfo } =
    adminTrpc.spin.getSpinInfo.useQuery(undefined, { enabled: hasLogin });
  const spinInfo = spinInfoRes?.info;

  const [luckyCoin, setLuckyCoin] = useState(new Decimal(0));
  const [ticket, setTicket] = useState(0);
  const progress = parseFloat(luckyCoin.toNumber().toFixed(2));
  const remainingCoin = useMemo(() => {
    return new Decimal(100).minus(luckyCoin).toDecimalPlaces(2);
  }, [luckyCoin]);
  const isEnd = progress >= 100;
  const spinResult = useRef<any | null>(null);
  // 邀请码
  const { data: inviteCode } = adminTrpc.invite.getInviteCode.useQuery();
  // 总次数
  const all100UCountsQuery = adminTrpc.spin.get100UCounts.useQuery();
  const all100UCounts = all100UCountsQuery.data?.counts ?? 0;
  const { mutateAsync: startSpin } = adminTrpc.spin.start.useMutation();

  // 用户名更新
  const { mutateAsync: updateUserInfo } =
    adminTrpc.spin.updateUserInfo.useMutation();
  const { userInfo } = useProfile();
  useEffect(() => {
    if (!spinInfo || !userInfo) return;
    if (!spinInfo?.username) {
      updateUserInfo({
        username: userInfo?.nickname ?? '',
        tgUsername: userInfo?.nickname ?? '',
      });
    }
  }, [spinInfo, userInfo]);

  // 助力用户信息
  function getBoostUserInfo(inviteCode: string) {
    return adminTrpcApi.invite.getInviterInfo.query({ inviteCode });
  }

  useEffect(() => {
    if (spinInfo) {
      setTicket(spinInfo.ticket);
      setLuckyCoin(spinInfo.luckyCoin);
    }
  }, [spinInfo]);

  useEffect(() => {
    if (spinInfo && !spinInfo.wallet && currentWallet) {
      adminTrpcApi.spin.setWallet.mutate({ wallet: currentWallet });
    }
  }, [spinInfo, currentWallet]);

  const handleStartSpin = async () => {
    setTicket(prev => prev - 1);
    const res = await startSpin();
    spinResult.current = res;
    return res;
  };

  const handleEndSpin = () => {
    if (spinResult.current?.result.type === 'luckyCoin') {
      setLuckyCoin(luckyCoin.plus(spinResult.current.result.amount));
    }
  };

  return {
    spinInfo,
    progress,
    ticket,
    luckyCoin,
    handleStartSpin,
    handleEndSpin,
    spinResult,
    isEnd,
    remainingCoin,
    all100UCountsQuery,
    all100UCounts,
    inviteCode,
    isLoadingSpinInfo,
    getBoostUserInfo,
    updateUserInfo,
  };
});
